/**
 * StandaloneWebBridge — IPlatformBridge implementation for desktop/mobile browsers (Dev & Preview)
 */

import type { IPlatformBridge, HapticStyle, HapticNotificationType } from './types';
import type { PlatformType, PlatformUserDTO, PlatformThemeParamsDTO } from '@tg-miniapp/shared-types';

export class StandaloneWebBridge implements IPlatformBridge {
  readonly platform: PlatformType = 'web';
  readonly isAvailable: boolean = true;

  get initData(): string {
    if (typeof window !== 'undefined') {
      try {
        const cached = sessionStorage.getItem('tg_init_data_backup') || sessionStorage.getItem('max_init_data_backup');
        if (cached) return cached;
      } catch {}

      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        const mockUser = {
          id: 1088744046,
          first_name: 'Разработчик',
          username: 'dev_user'
        };
        const authDate = Math.floor(Date.now() / 1000);
        return `user=${encodeURIComponent(JSON.stringify(mockUser))}&auth_date=${authDate}&hash=mock_hash`;
      }
    }
    return '';
  }

  get user(): PlatformUserDTO | null {
    if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
      return {
        id: '1088744046',
        rawId: 1088744046,
        platform: 'web',
        firstName: 'Разработчик',
        username: 'dev_user'
      };
    }
    return null;
  }

  get startParam(): string | undefined {
    if (typeof window !== 'undefined') {
      const searchParams = new URLSearchParams(window.location.search);
      return searchParams.get('startapp') || searchParams.get('start_param') || undefined;
    }
    return undefined;
  }

  get colorScheme(): 'light' | 'dark' {
    if (typeof window !== 'undefined' && window.matchMedia) {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return 'light';
  }

  get themeParams(): PlatformThemeParamsDTO {
    return {};
  }

  ready(): void {}
  expand(): void {}
  close(): void {
    if (typeof window !== 'undefined') {
      window.close();
    }
  }

  showBackButton(onClick: () => void): () => void {
    const handlePop = () => onClick();
    window.addEventListener('popstate', handlePop);
    return () => window.removeEventListener('popstate', handlePop);
  }

  hapticImpact(_style: HapticStyle = 'light'): void {
    try {
      if (typeof navigator !== 'undefined' && navigator.vibrate) {
        navigator.vibrate(10);
      }
    } catch {}
  }

  hapticNotification(_type: HapticNotificationType): void {
    try {
      if (typeof navigator !== 'undefined' && navigator.vibrate) {
        navigator.vibrate(20);
      }
    } catch {}
  }

  hapticSelection(): void {
    try {
      if (typeof navigator !== 'undefined' && navigator.vibrate) {
        navigator.vibrate(5);
      }
    } catch {}
  }

  openLink(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  shareContent(text: string, url?: string): void {
    if (typeof navigator !== 'undefined' && navigator.share) {
      navigator.share({ title: 'Поделиться', text, url }).catch(() => {});
    } else {
      window.open(`https://t.me/share/url?url=${encodeURIComponent(url || window.location.href)}&text=${encodeURIComponent(text)}`, '_blank');
    }
  }
}
